import { createStyles, makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import {
  BorrowerPortalCard,
  getGridCardStyles,
} from '@roc/feature-borrower-portal-core';
import { useEffect } from 'react';
import { DashboardRounded } from '@material-ui/icons';
import { BorrowerPortalPageLayout } from '../../../../apps/borrower-portal-v2/src/app/components/borrowerPortalPageLayout';
import { Box, Grid } from '@material-ui/core';
import { BreadcrumbsNew } from '@roc/ui';
import { MyReferralsDataGrid } from './myReferralsDataGrid';
import { useStore } from '@roc/client-portal-shared/hooks';
import { Alert, AlertTitle } from '@material-ui/lab';

const useStyles = makeStyles(theme => createStyles({}));

export const MyReferrals = observer(() => {
  const classes = getGridCardStyles();
  const { globalStore, userStore,  referralWiringInformationStore } = useStore();
  const { breadCrumbsStore } = globalStore;
  const { breadCrumbItems } = breadCrumbsStore;

  useEffect(() => {
    breadCrumbsStore.setBreadCrumbItems([
      {
        link: true,
        title: 'Dashboard',
        url: globalStore.routeBaseUrl,
        icon: <DashboardRounded />,
      },
      {
        link: false,
        title: 'My Referrals',
      },
    ]);
    referralWiringInformationStore.getReferralWiringInformation(userStore.userInformation.userId);
  }, []);

  return (
    <BorrowerPortalPageLayout>
      <Box mb={3}>
        <BreadcrumbsNew
          breadCrumbItems={breadCrumbItems}
          separator={<span>&#187;</span>}
        />
      </Box>
      {!referralWiringInformationStore.isSigned &&<Grid container spacing={2} style={{
        marginBottom: 16
      }}>
        <Grid item xs={12} md={12}>
          <Alert severity="info">
            <AlertTitle>Update your Referral ACH Information</AlertTitle>
            Please update your Referral ACH Information on you Profile so
            that you can receive payment for your referrals once they close a
            loan.
          </Alert>
        </Grid>
      </Grid>}
      <BorrowerPortalCard
        cardTitle={'My Referrals'}
        cardContentClassName={classes.cardContent}
      >
        <MyReferralsDataGrid />
      </BorrowerPortalCard>
    </BorrowerPortalPageLayout>
  );
});
